// Public homepage for the platform's self-serve and managed delivery models.
import { TRDRHeader } from "@/components/layout/trdr-header";
import { TRDRFooter } from "@/components/layout/trdr-footer";
import { TRDRHeroSection } from "@/components/sections/trdr-hero-section";
import { ToolsSection } from "@/components/sections/tools-section";
import { OperatingModelSection } from "@/components/sections/operating-model-section";
import { FAQSection } from "@/components/sections/faq-section";
import { CTASection } from "@/components/sections/cta-section";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <TRDRHeader />
      <main>
        <TRDRHeroSection />
        <ToolsSection />
        <OperatingModelSection />
        <FAQSection />
        <CTASection />
      </main>
      <TRDRFooter />
    </div>
  );
};

export default LandingPage;
